
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor-privacy-policy",
      function () {
        return require("private-next-pages/vendor-privacy-policy.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor-privacy-policy"])
      });
    }
  